import * as React from 'react';
import { SVGProps } from 'react';

const OrderIconOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 24"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M14 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V21C18 21.2652 17.8946 21.5196 17.7071 21.7071C17.5196 21.8946 17.2652 22 17 22H1C0.734784 22 0.48043 21.8946 0.292893 21.7071C0.105357 21.5196 0 21.2652 0 21V3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2H4V0H6V2H12V0H14V2ZM14 4V6H12V4H6V6H4V4H2V20H16V4H14ZM4 8H14V10H4V8ZM4 12H14V14H4V12Z" />
  </svg>
);

export default OrderIconOutlined;
